import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { Modal } from '../../../../core/services/modal';
import { Button } from '../../../ui/button/button';

@Component({
  selector: 'app-base-modal',
  imports: [CommonModule, Button, TranslatePipe],
  templateUrl: './base-modal.html',
  styleUrl: './base-modal.css',
})
export class BaseModal {
  @Input() options?: any;
  @Output() handleBtn = new EventEmitter<void>();

  constructor(private modalService: Modal) { }

  close(): void {
    this.modalService.close();
  }

  confirm(): void {
    // If parent provided a custom callback, call it
    if (this.options?.onConfirm && typeof this.options.onConfirm === 'function') {
      this.options.onConfirm();
    } else {
      // Otherwise, emit event to parent or close by default
      this.handleBtn.emit();
      this.close();
    }
  }

  cancel(): void {
    // If parent provided a custom callback, call it
    if (this.options?.onCancel && typeof this.options.onCancel === 'function') {
      this.options.onCancel();
    } else {
      // Otherwise, emit event to parent or close by default
      this.handleBtn.emit();
      this.close();
    }
  }
}
